<template>
  <div style="height: 100%;width: 100%;overflow: auto">
    <frame-form  ref="orgUserImport" componentParam="org_user_import"
                 :init-data="lastLog"   ></frame-form>
  </div>
</template>

<script>
export default {
  name: "ImportUser",
  components: {},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      lastLog: {},
    }
  },

  methods: {

  },

  beforeUnmount() {
    // 当组件卸载时执行的方法
    this.$fn.reloadTreeData();
  }
}

</script>

<style scoped>

</style>